(() => {
  if (customElements.get('aura-gift-options')) return;
  class AuraGiftOptions extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.box = this.querySelector('input[name="properties[Gift wrap]"]');
      this.message = this.querySelector('[data-gift-message-name]');
      this.panel = this.querySelector('.ae-gift-options__message');
      if (!this.box) return;
      this.ready = true;
      this.addEventListener('change', () => this.sync());
      this.addEventListener('input', () => this.sync());
      this.sync();
    }
    sync() {
      if (!this.message || !this.panel) return;
      const selected = this.box.checked;
      this.panel.hidden = !selected;
      this.message.disabled = !selected;
      if (selected && this.message.value.trim()) {
        this.message.name = this.message.dataset.giftMessageName;
      } else {
        this.message.removeAttribute('name');
      }
    }
  }
  customElements.define('aura-gift-options', AuraGiftOptions);
  document.addEventListener('formdata', event => {
    for (const field of Array.from(event.target.elements || [])) {
      if (!field.matches('[data-gift-message-name]')) continue;
      const group = field.closest('aura-gift-options');
      const box = group?.querySelector('input[name="properties[Gift wrap]"]');
      const key = field.dataset.giftMessageName;
      if (box?.form === event.target && box.checked && field.value.trim()) {
        event.formData.set(key, field.value);
      } else {
        event.formData.delete(key);
      }
    }
    for (const [key, value] of event.formData.entries()) {
      if (/^properties\[gift message\??\]$/i.test(key) && typeof value === 'string' && !value.trim()) {
        event.formData.delete(key);
      }
    }
  }, true);
  const syncAll = () => document.querySelectorAll('aura-gift-options').forEach(group => group.sync());
  window.addEventListener('pageshow', syncAll);
  document.addEventListener('reset', () => queueMicrotask(syncAll), true);
})();
